import SingleChoice from './SingleChoice'
import MultiChoice from './MultiChoice'
import MatrixScale from './MatrixScale'
import SingleScale from './SingleScale'
import MatrixSelect from './MatrixSelect'
import MatrixFill from './MatrixFill'
import SingleSelect from './SingleSelect'
import MultipleSelect from './MultipleSelect'
import MatrixSingleChoice from './MatrixSingleChoice'
import DateSelect from './DateSelect'
import Linkage from './Linkage'
import MatrixMultipleChoice from './MatrixMultipleChoice'
import MatrixGravity from './MatrixGravity'
import MatrixCompose from './MatrixCompose'
import MultipleBlanks from './MultipleBlanks'
import MatrixScroll from './MatrixScroll' //矩阵滑动
import MatirxAuto from './MatirxAuto' //自增表格
import Blanks from './Blanks' //填空
import Sort from './Sort' //排序
import Downloadable from './Downloadable' //排序
import Classification from './Classification' //分类
import ImageChoice from './ImageChoice' //图片选择 单选
import ImageMultipleChoice from './ImageMultipleChoice' //图片选择 多选
import CascadeRegion from './CascadeRegion' //区块级联
import Total from './Total'
import MaxDiff from './MaxDiff'

export {
  SingleChoice,
  MultiChoice,
  MatrixScale,
  SingleScale,
  MatrixSelect,
  MatrixFill,
  SingleSelect,
  MultipleSelect,
  MatrixSingleChoice,
  DateSelect,
  Linkage,
  MatrixMultipleChoice,
  MatrixGravity,
  MatrixCompose,
  MultipleBlanks,
  MatrixScroll,
  MatirxAuto,
  Blanks,
  Sort,
  Downloadable,
  Classification,
  ImageChoice,
  ImageMultipleChoice,
  CascadeRegion,
  Total,
  MaxDiff
}
